<template>
    <section class="main">

        <v-page-header :title="$t('account.profile.email.confirm')" :showPrevButton="false" />

        <div class="grid-container">
            <div class="grid-x">
                <div class="cell medium-9 medium-offset-1 large-11 large-offset-0">
                    <div class="box" v-if="objectError !== null">
                        <div class="form-message form-message--error" >
                            {{ objectError }}
                        </div>
                    </div>
                    <div class="box" v-if="objectSuccess !== null">
                        <div class="form-message form-message--success" >
                            {{ objectSuccess }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import PageHeader from '../partials/PageHeader';

    export default {
        data() {
            return {
                objectError     : null,
                objectSuccess   : null,
                object          : {
                    token           : this.$route.params.pathMatch
                }
            }
        },
        components : {
            vPageHeader : PageHeader,
        },
        created : function () {
            this.onSubmitObject();
        },
        methods: {
            onSubmitObject: function () {
                this.objectError    = null;
                this.objectSuccess  = null;

                let promise = this.$api.clearParams()
                    .post('accounts/me/confirm-email', this.object);

                promise.then((response => {
                    this.objectSuccess      = this.$t('account.profile.email.confirm.success');
                }).bind(this)).catch((error => {
                    this.objectError        = this.$t('form.error_form');

                    console.log(error);
                }).bind(this));
            }
        }
    }
</script>
